import angular from 'angular';
import AddressSelectorComponent from './address-selector.component';
import FrAutocompleteComponent from '../../common/autocomplete/autocomplete.component';
import HighlightFilter from '../../common/filters/highlight.filter';

let address = angular
	.module('addressSelector', [])
	.filter('highlight', HighlightFilter)
	.component('frAutocomplete', FrAutocompleteComponent)	
	.component('addressSelector', AddressSelectorComponent)
	.name;

export default address;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/address-selector/address-selector.module.js